<template>
  <div class="schoolChoose" :class="{ inApp: $root.$data.isApp || isMiniProgram}">
    <common-title titleName="智能规划" :bcColor="'#F7F8FC'" :isAPPShow="true" :zIndex="100" />
    <div class="submit">
      <img src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/hasfinish.png" alt="" />
      <p>择校老师已为您提供一对一择校服务</p>
      <p>祝您考研顺利，前程似锦！</p>
    </div>
  </div>
</template>
<script>
import { whatEev } from '@/utils/tools';
import CommonTitle from '@/components/header/CommonTitle.vue';

export default {
  data() {
    return {
      isMiniProgram: false,
    };
  },
  components: {
    CommonTitle
  },
  watch: {},
  computed: {},
  created() {
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
    }
  },
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.schoolChoose {
  height: 100%;
  background-color: #f7f8fc;
  padding-top: 430px;
  .submit {
    img {
      display: block;
      width: 340px;
      height: 242px;
      margin: 0 auto 13px;
    }
    p {
      font-size: 25px;
      font-weight: 400;
      color: #333333;
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
.inApp {
  padding-top: 330px;
}
</style>
